import { useMemo } from 'react';
import { image } from '../../../../../utils/data/baseUrl';
import { useFeatureToggle } from '../../../../../hooks/useFeatureToggle';
import { useOnboarding } from '../../../../../redux/reducer/content';

export default function useMarch8ModalHoliday() {
  const gameTamagotchiPromo8March = useFeatureToggle('gameTamagotchiPromo8March');
  const { marchModalsVisible } = useOnboarding();

  return useMemo(
    () =>
      marchModalsVisible &&
      gameTamagotchiPromo8March && {
        id: 'march8ModalHoliday',
        type: 'slideModal',
        props: {
          slides: [
            {
              title: 'march8ModalHolidayContent.slides.0.title',
              text: ['march8ModalHolidayContent.slides.0.text'],
              img: image('8march/holiday8march.png'),
              buttons: [{ attr: { text: 'march8ModalHolidayContent.slides.0.button1.text' }, action: 'next' }],
            },
            {
              title: 'march8ModalHolidayContent.slides.1.title',
              text: ['march8ModalHolidayContent.slides.1.text'],
              img: image('8march/holiday8march.png'),
              buttons: [
                { attr: { text: 'march8ModalHolidayContent.slides.1.button1.text' }, action: 'toChallenges' },
                {
                  attr: {
                    text: 'march8ModalHolidayContent.slides.1.button2.text',
                    className: 'custom-button_gray',
                  },
                  action: 'next',
                },
              ],
            },
          ],
        },
      },
    [gameTamagotchiPromo8March, marchModalsVisible],
  );
}
